export const BUSINESS_CASE_SIGNAL_CODES = [
  'customerAwaitingReply',
  'overdueTask',
  'missingNextStep',
  'goingCold',
  'engagement',
  'offerNotSent',
  'offerSentNoResponse',
  'offerOpenedNoReply',
  'offerExpiringSoon',
  'offerExpired',
  'testDriveCompletedNoFollowUp',
  'testDrivePlannedSoon',
  'depositUnpaid',
  'invoiceUnpaid',
  'closeBlocked',
  'expectedPurchaseDatePassed',
  'expectedPriceAboveMax',
] as const;
